module.exports = __webpack_public_path__ + "static/media/background.7eb09002.jpg";